import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Button, MenuItem, Select, Typography } from '@mui/material';

export default function SiteAnalytics() {
  const [days, setDays] = useState(30);
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const load = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/analytics/summary?days=${days}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setData(response.data); setError('');
    } catch (err) { setError(err.response?.data?.message || 'Unable to load analytics.'); }
  };
  useEffect(() => { load(); }, [days]);
  const Chart = ({ title, rows, label }) => {
    const max = Math.max(1, ...rows.map((row) => Number(row.visits) || 0));
    return <Box className="analytics-card"><Typography variant="h6">{title}</Typography><div className="analytics-chart">{rows.map((row) => <div className="analytics-bar-row" key={String(row[label])}><span>{String(row[label])}</span><div className="analytics-bar-track"><i style={{ width: `${Math.max(3, (Number(row.visits) / max) * 100)}%` }} /></div><strong>{row.visits}</strong></div>)}</div></Box>;
  };
  return <Box className="site-analytics-panel">
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2, mb: 3 }}>
      <div><Typography variant="h5">Visitor analytics</Typography><Typography color="text.secondary">Privacy-safe page visits by day, section, and hour. No emails or IP addresses are stored.</Typography></div>
      <Box sx={{ display: 'flex', gap: 1 }}><Select size="small" value={days} onChange={(e) => setDays(e.target.value)}><MenuItem value={7}>7 days</MenuItem><MenuItem value={30}>30 days</MenuItem><MenuItem value={90}>90 days</MenuItem></Select><Button variant="outlined" onClick={load}>Refresh</Button></Box>
    </Box>
    {error && <Typography color="error">{error}</Typography>}
    {data && <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))', gap: 2 }}>
      <Chart title="Visits by section" rows={data.sections} label="section" />
      <Chart title="Visits by day" rows={data.daily.map((row) => ({ ...row, day: String(row.day).slice(0, 10) }))} label="day" />
      <Chart title="Visits by hour" rows={data.hours.map((row) => ({ ...row, hour: `${String(row.hour).padStart(2, '0')}:00` }))} label="hour" />
    </Box>}
  </Box>;
}
